var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7376 6.33297L23.147 0.755899C23.0367 0.622209 22.9055 0.516095 22.761 0.443681C22.6164 0.371267 22.4614 0.333984 22.3048 0.333984C22.1482 0.333984 21.9931 0.371267 21.8486 0.443681C21.704 0.516095 21.5728 0.622209 21.4626 0.755899C21.2416 1.02315 21.1176 1.38466 21.1176 1.76148C21.1176 2.13831 21.2416 2.49982 21.4626 2.76707L25.6855 7.8877H1.49871C1.1841 7.8877 0.882389 8.03798 0.659932 8.30547C0.437475 8.57297 0.3125 8.93577 0.3125 9.31406C0.3125 9.69236 0.437475 10.0552 0.659932 10.3227C0.882389 10.5901 1.1841 10.7404 1.49871 10.7404H25.7566L21.4626 15.8896C21.3514 16.0222 21.2631 16.1799 21.2029 16.3538C21.1427 16.5276 21.1117 16.714 21.1117 16.9023C21.1117 17.0906 21.1427 17.277 21.2029 17.4508C21.2631 17.6247 21.3514 17.7824 21.4626 17.915C21.5728 18.0487 21.704 18.1548 21.8486 18.2272C21.9931 18.2996 22.1482 18.3369 22.3048 18.3369C22.4614 18.3369 22.6164 18.2996 22.761 18.2272C22.9055 18.1548 23.0367 18.0487 23.147 17.915L27.7376 12.3807C28.404 11.5784 28.7783 10.4908 28.7783 9.35685C28.7783 8.22289 28.404 7.1353 27.7376 6.33297Z",
    fill: "#F2F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.b435bb078bf8f887c84a50dd122cb268.svg";
export { ForwardRef as ReactComponent };